export const DEFAULT_COMPONENT_CONFIG = {
  navbar: {
    isNavbarOpen: true,
    isLogoVisible: true,
    isTitleVisible: true,
    isExitButtonVisible: true,
  },
  isBannerVisible: true,
  subNavbar: {
    isSubNavbarVisible: true,
    isDescriptionVisible: true,
    isSpecialitiesVisible: true,
    isSessionTimeVisible: true,
  },
  isVideoPlayerVisible: true,
  engagement: {
    isEngagementVisible: true,
    isChatVisible: true,
    isQNAVisible: true,
    isPollsVisible: true,
  },
  isSpeakersVisible: true,
  isFooterVisible: true,
};

export const getDefaultComponentConfig = () =>
  JSON.parse(JSON.stringify(DEFAULT_COMPONENT_CONFIG));

export const SECTIONS = [
  {
    title: "Navigation",
    key: "navbar",
    fields: [
      { label: "Header", key: "isNavbarOpen" },
      { label: "Logo Visible", key: "isLogoVisible" },
      { label: "Title Visible", key: "isTitleVisible" },
      { label: "Exit Button", key: "isExitButtonVisible" },
    ],
  },
  {
    title: "Banner",
    key: "banner",
    flat: true,
    fields: [{ label: "Banner Visible", key: "isBannerVisible" }],
  },
  {
    title: "Session Info",
    key: "subNavbar",
    fields: [
      { label: "Description Visible", key: "isSubNavbarVisible" },
      // Hidden from the Settings modal; the config key itself is still kept and published.
      // { label: "Description", key: "isDescriptionVisible" },
      { label: "Specialities", key: "isSpecialitiesVisible" },
      { label: "Session Time", key: "isSessionTimeVisible" },
    ],
  },
  {
    title: "Video Player",
    key: "videoPlayer",
    flat: true,
    fields: [{ label: "Player Visible", key: "isVideoPlayerVisible" }],
  },
  {
    title: "Engagement",
    key: "engagement",
    fields: [
      { label: "All Engagement", key: "isEngagementVisible" },
      { label: "Chat", key: "isChatVisible" },
      { label: "Q&A", key: "isQNAVisible" },
      { label: "Polls", key: "isPollsVisible" },
    ],
  },
  {
    title: "Speakers",
    key: "speakers",
    flat: true,
    fields: [{ label: "Speakers Visible", key: "isSpeakersVisible" }],
  },
  {
    title: "Footer",
    key: "footer",
    flat: true,
    fields: [{ label: "Footer Visible", key: "isFooterVisible" }],
  },
];

// Like / Share on the viewer page. Not part of `setting`: they are cme-common's
// detail.isLikeEnabled / detail.isShareEnabled, so the Settings modal adds them to the
// Session Info card and publishes them as a detail update (adminStore.updateDetailFlags).
export const DETAIL_TOGGLES = [
  { label: "Like Button", key: "isLikeEnabled" },
  { label: "Share Button", key: "isShareEnabled" },
];

export const MessageText = {
  statusScreens: {
    onHold: {
      heading: "Session On Hold",
      noteLabel: "Waiting for Organizer",
      noteText:
        "This page will refresh automatically once the session resumes.",
    },
    postponed: {
      heading: "Session Postponed",
      noteLabel: "Notification",
      noteText: "You will be notified once the new schedule is finalized.",
    },
    rescheduled: {
      heading: "Session Rescheduled",
      noteLabel: "New Schedule Pending",
      noteText:
        "You will be notified once the new date and time are confirmed.",
    },
    canceled: {
      heading: "Session Canceled",
      noteLabel: "Notification",
      noteText: "This session will not take place. Thank you for your interest.",
    },
    ended: {
      heading: "Session Has Ended",
      buttonLabel: "Return to Platform",
    },
    tba: {
      heading: "Schedule To Be Announced",
      noteLabel: "Coming Soon",
    },
    unknown: {
      heading: "Session unavailable",
      message: "This session can't be displayed right now.",
    },
    upcoming: {
      title: "Upcoming Session",
      description:
        "Join us for this upcoming session. Session details and agenda will be shared with registered attendees.",
      startsInLabel: "Session starts in",
    },
    waitingRoom: {
      heading: "Session is about to start",
      message:
        "The speaker has joined and is preparing to go live. Please wait in this room, the stream will begin automatically.",
      statusText: "Waiting for stream to start...",
    },
  },
  accessDenied: {
    title: "Access denied",
    default: "You don't have permission to do this.",
    section: "Your admin access doesn't include permission for this section.",
    manageUsers:
      "Your admin access doesn't include permission to manage users on this session.",
    startMeeting: "You don't have permission to start the meeting.",
  },
  realtimeDown: {
    title: "Technical issue detected.",
    message: "Please contact the technical team.",
    supportLabel: "Support email:",
    // From SUPPORT_EMAIL (.env); the default keeps the link working when it is unset.
    supportEmail: String(import.meta.env?.SUPPORT_EMAIL || "").trim() || "support@clirnet.com",
    retry: "Retry",
    close: "Close",
  },
  emptyPolls: {
    title: "No polls available",
    description: "Waiting for the backend to publish polls",
  },
  emptyQna: {
    title: "No questions available",
    description: "Waiting for the backend to publish questions",
  },
  emptyQuizzes: {
    title: "No quizzes available",
    description: "Waiting for the backend to publish quiz items",
  },
};
